import request from '../utils/Request';
import { Methods } from '../config';
import { TemplateType } from '../config/template';

const baseURL = 'template';

const templateService = {
  getItem: (id) => {
    return request({
      resource: `${baseURL}/${encodeURIComponent(id)}`,
    });
  },

  getItems: (data) => {
    return request({
      method: Methods.POST,
      resource: `${baseURL}/data`,
      data,
    });
  },

  getSmsTemplates: async () => {
    const templates = [];
    let page = 0;
    let result;
    do {
      result = await templateService.getItems({
        filter: { filterModel: {
          items: [{ field: 'templateType', operator: 'equals', value: TemplateType.SMS }],
          logicOperator: 'and',
        } },
        sorting: { sortModel: [{ field: 'id', sort: 'asc' }] },
        pagination: { paginationModel: { page, pageSize: 100 } },
      });
      templates.push(...result.rows);
      page += 1;
    } while (result.rows.length > 0 && templates.length < result.rowCount);

    return Promise.all(templates.map((template) =>
      template.body == null ? templateService.getItem(template.id) : template
    ));
  },

  createItem: (data) => {
    return request({
      method: Methods.POST,
      resource: `${baseURL}`,
      data,
    });
  },

  updateItem: (data) => {
    return request({
      method: Methods.PUT,
      resource: `${baseURL}`,
      data,
    });
  },

  deleteItem: (data, id) => {
    return request({
      method: Methods.DELETE,
      resource: `${baseURL}/${encodeURIComponent(id)}`,
      data,
    });
  },
};

export default templateService;
